import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { IndianIndices } from '../indian-indices-widget/indian-indices';

const IndianIndicesWidget = ({ data }) => {
  const queryClient = new QueryClient();
  return (
    <QueryClientProvider client={queryClient}>
      <IndianIndices />
    </QueryClientProvider>
  );
};

export { IndianIndicesWidget };
